export enum RepaymentFrequency {
    Weekly = 'Weekly',
    Fortnightly = 'Fortnightly',
    Monthly = 'Monthly'
}

export const RepaymentFrequencyLabels: Record<RepaymentFrequency, string> = {
    [RepaymentFrequency.Weekly]: 'Weekly',
    [RepaymentFrequency.Fortnightly]: 'Fortnightly',
    [RepaymentFrequency.Monthly]: 'Monthly'
};

const REPAYMENT_FREQUENCY_SET = new Set<RepaymentFrequency>(Object.values(RepaymentFrequency));

const isRepaymentFrequency = (frequency: string): frequency is RepaymentFrequency => {
    return REPAYMENT_FREQUENCY_SET.has(frequency as RepaymentFrequency);
};

export const getRepaymentFrequencyLabel = (frequency: string | null | undefined) => {
    if (!frequency) {
        return '';
    }

    return isRepaymentFrequency(frequency) ? RepaymentFrequencyLabels[frequency] : frequency;
};
